module.exports = __webpack_public_path__ + "img/ptop.7658c872.png";